import { cn, Label } from '@c2fo/liquidity';

interface RadioInputProps {
  checked: boolean;
  description?: string;
  id?: string;
  label: React.ReactNode;
  onChange: () => void;
  value: string;
  name?: string;
  className?: string;
  disabled?: boolean;
  variant?: 'default' | 'light';
  size?: 'small' | 'large';
  color?: 'green' | 'blue';
  endSlot?: React.ReactNode;
}

const RadioInput = ({
  checked,
  description,
  id,
  label,
  onChange,
  value,
  name,
  className,
  disabled = false,
  variant = 'default',
  size = 'small',
  color = 'green',
  endSlot,
}: RadioInputProps) => (
  <Label
    htmlFor={id ?? value}
    className={cn(
      'flex w-full cursor-pointer items-start rounded-md border-[0.5px] border-stroke bg-white p-2 transition-colors duration-200 [&_span]:w-full',
      {
        'hover:bg-primary-50': variant === 'default',
        'border-primary-500 bg-primary-100 hover:border-primary-500 hover:bg-primary-100':
          checked && variant === 'default',
        'border-primary-500 hover:border-primary-500': checked && variant === 'light',
        'cursor-not-allowed opacity-38': disabled,
        'p-4': size === 'large',
        'hover:border-stroke': color === 'blue',
        'border-stroke bg-lightBlue-500 hover:border-stroke': checked && color === 'blue',
        'rounded-xl': size === 'large',
      },
      className
    )}
  >
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      <div className="flex items-center gap-3">
        <input
          id={id ?? value}
          className={cn(
            'h-4 w-4 shrink-0 cursor-pointer appearance-none rounded-full border-2 border-gray-400 checked:border-green-500 checked:bg-green-500 checked:ring-2 checked:ring-inset checked:ring-white',
            {
              'h-6 w-6 checked:ring-4': size === 'large',
              'checked:border-secondary-500 checked:bg-secondary-500': color === 'blue',
            }
          )}
          checked={checked}
          name={name ?? value}
          onChange={onChange}
          type="radio"
          value={value}
          disabled={disabled}
        />
        <div>
          <span>{label}</span>
          <p className="text-sm font-normal text-text-secondary">{description}</p>
        </div>
      </div>
      {endSlot && <div className="sm:ml-auto">{endSlot}</div>}
    </div>
  </Label>
);

export default RadioInput;
